import { useTranslation } from "@redotech/redo-i18n";
import { viewTypes } from "@redotech/redo-views-common/views";
import { memo } from "react";
import {
  RedoModal,
  RedoModalButtonProps,
} from "./arbiter-components/modal/redo-modal";

export const DeleteTableViewModal = memo(function DeleteTableViewModal({
  open,
  setOpen,
  view,
  onDelete,
  variant = "legacy",
  subtitle,
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
  view: viewTypes[keyof viewTypes];
  onDelete: () => void;
  /** "prototype" is the new returns experience's design; "legacy" is unchanged for every other table. */
  variant?: "legacy" | "prototype";
  /** Prototype variant: what deleting means on this table. */
  subtitle?: string;
}) {
  const { t } = useTranslation();
  if (variant === "legacy") {
    return (
      <RedoModal
        isOpen={open}
        onModalCloseRequested={() => setOpen(false)}
        primaryButton={{ onClick: onDelete, text: t("Delete") }}
        secondaryButton={{ onClick: () => setOpen(false), text: t("Cancel") }}
        subtitle={t("Are you sure you want to delete this view?")}
        theme="error"
        title={t("Delete view - {{viewName}}", { viewName: view.name })}
      />
    );
  }

  const primaryButtonProps: RedoModalButtonProps = {
    onClick: onDelete,
    text: t("Delete view"),
    theme: "destructive",
    size: "xs",
  };

  const secondaryButtonProps: RedoModalButtonProps = {
    onClick: () => setOpen(false),
    text: t("Cancel"),
    size: "xs",
  };

  return (
    <RedoModal
      isOpen={open}
      modalSize="sm"
      onModalCloseRequested={() => setOpen(false)}
      primaryButton={primaryButtonProps}
      secondaryButton={secondaryButtonProps}
      subtitle={
        subtitle ??
        t(
          "“{{viewName}}” will be removed from your views. The records in it are not affected.",
          { viewName: view.name },
        )
      }
      theme="error"
      title={t("Delete this view?")}
    />
  );
});
